import { FC } from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';

export const AdminLayout: FC = () => (
  <Box sx={{ p: { xs: 2, md: 4 } }}>
    <Outlet />
  </Box>
);
